class EventEmitter {
    constructor() {
        this.events = {};
    }

    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }

    emit(event, ...args) {
        if (this.events[event]) {
            this.events[event].forEach(listener => listener(...args));
        }
    }

    off(event, listenerToRemove) {
        if (!this.events[event]) return;

        this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove);
    }
}

class LenisScroll {
    constructor(eventEmitter) {
        this.lenis = null;
        this.eventEmitter = eventEmitter;
    }
    destroy(){
        if (this.lenis) {
            this.lenis.destroy();
        }
    }
    initialize() {
        if (this.lenis) {
            this.lenis.destroy();
        }

        this.lenis = new Lenis({
            wrapper: document.querySelector('main'),
            easing: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
        });

        const raf = (time) => {
            this.lenis.raf(time);
            requestAnimationFrame(raf);
        };

        requestAnimationFrame(raf);

        this.lenis.on('scroll', (e) => {
            this.eventEmitter.emit('scroll', e);
        });
    }

    raf(time) {
        if (this.lenis) {
            this.lenis.raf(time);
        }
    }
}

export { EventEmitter, LenisScroll };
